import React from "react";
import { styled, Tooltip, tooltipClasses, Typography } from "@mui/material";
import {
  ACTION_TYPE,
  ACTIONABLE_ITEM_OBJ_MAPPING,
  ACTIONABLE_ITEM_TYPE_STRING,
} from "../../utils/constants";
import FormatISODateTime from "../../../../../../../global/FormatISODateTime";
import { Circle } from "@mui/icons-material";
import { TooltipStyling } from "../../../FollowUps/CaseFollowUps/components/ui/InfoTooltip/TooltipStyling";

export default function FollowUpAccordionSummary({ accordionItem }) {
  
  const getTitle = () => {
    if (accordionItem.actionType === ACTION_TYPE.CLIENT_FOLLOW_UP.toString()) {
      return accordionItem?.[
        ACTIONABLE_ITEM_OBJ_MAPPING[accordionItem.actionType]
      ]?.client.name;
    }
    return accordionItem?.[
      ACTIONABLE_ITEM_OBJ_MAPPING[accordionItem.actionType]
    ]?.name;
  };
  const title = getTitle();
  const dateTime = FormatISODateTime(
    new Date(accordionItem.completedAt).toISOString()
  );

  const HtmlInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: TooltipStyling,
  }));

  return (
    <div className="w-full flex items-center">
      <div className="w-[6%]">
        {accordionItem.call_associated && (
          <HtmlInfoTooltip title="This Follow Up is linked with a call.">
            <Circle className="text-blue-400 text-xs" />
          </HtmlInfoTooltip>
        )}
      </div>
      <div className="w-[94%]">
        <Typography className="text-md w-1/2 truncate capitalize">
          {title}
        </Typography>
        <Typography className="text-xs flex flex-row justify-between">
          <div className="w-1/2">
            <span>{ACTIONABLE_ITEM_TYPE_STRING[accordionItem.actionType]}</span>
          </div>
          <span>{dateTime}</span>
        </Typography>
      </div>
    </div>
  );
}
